import {QuoteAddress} from '../models';

export default (vuexstore: any) => {
    vuexstore.subscribe((mutation: any, state: any) => {
        const affectedMutations = ['checkout/setShippingAddress'];
        const prop: any = {
            'checkout/setShippingAddress': 'shippingAddress',
        };

        if (
            affectedMutations.includes(mutation.type) &&
            vuexstore.getters['user/isLoggedin'] &&
            !vuexstore.getters['user/hasAddresses']
        ) {
            const address = state.checkout[prop[mutation.type]] as QuoteAddress;
            address.save_in_address_book = 1;
            address.default_billing = true;
            address.default_shipping = true;
        }
    });
};
